export default __webpack_public_path__ + "static/media/colorectal4.a22a8bb1.jpg";